import React, { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { colors } from '../../tokens';

interface AppLayoutProps {
  children: ReactNode;
  onNavigate?: (page: string) => void;
  currentPage?: string;
  showConnectButton?: boolean;
}

export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  onNavigate,
  currentPage,
  showConnectButton = true,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: colors.background.pageBackground.primary,
      }}
    >
      {/* Sidebar */}
      <Sidebar
        onNavigate={onNavigate}
        currentPage={currentPage}
        showConnectButton={showConnectButton}
      />

      {/* Main Content */}
      <main
        style={{
          marginLeft: '220px', // Same as sidebar width
          flex: 1,
          minHeight: '100vh',
          width: 'calc(100% - 220px)',
        }}
        className="main-content"
      >
        {children}
      </main>

      {/* Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          .main-content {
            margin-left: 0 !important;
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
};
